import translate from "@insite/client-framework/Translate";
import { ThemeProps, css, withTheme } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import React from "react";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect, useSelector } from "react-redux";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import Typography from "@insite/mobius/Typography";
import ADIBrandsRewardsModal from "@NA/Components/ADIBrandsRewardsModal";
import ProRewardsIcon from "@NA/Icons/ProRewardsIcon";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import Img from "@insite/mobius/Img/Img";
import { brandImagesLink, displayBrandImages, hmiSettingsFeaturedSupplier1, hmiSettingsFeaturedSupplier2 } from "@NA/Utils/Utility";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
export interface ADIProrewardsandsuppliersStyles {
    ADIProrewardsandsuppliersStyles?: ADIProrewardsandsuppliersStyles;
}
const mapStateToProps = (state: ApplicationState) => {
    return {
        countries: getCurrentCountries(state),
    };
};
interface OwnProps {
    closeSupplierModal: Function;
    isOpenSupplierModal: boolean;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ThemeProps<BaseTheme>;
const ADIProrewardsandsuppliers = ({ closeSupplierModal, isOpenSupplierModal }: Props) => {
    const proRewardsModalSupplier1 = hmiSettingsFeaturedSupplier1();
    const proRewardsModalSupplier2 = hmiSettingsFeaturedSupplier2();
    const hmiRewardsSettingSettings:any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );
    const checkStyleCondtions = () => {
        return (
            <>
                <GridContainer className="prorewardsheadingsection">
                    <GridItem className="prorewardsicon">
                        <Button>
                            <ButtonIcon src={ProRewardsIcon} />
                        </Button>
                    </GridItem>
                    <GridItem className="prorewardsheading">

                        <Typography className="prorewardstitle" as="h2">
                            {translate(hmiRewardsSettingSettings.suppliersPopupTitle)}
                        </Typography>

                    </GridItem>
                </GridContainer>
            </>
        );
    };

    return (
        <ADIBrandsRewardsModal
            errorStyle={false}
            headline={checkStyleCondtions()}
            subheading={translate(
                hmiRewardsSettingSettings.suppliersPopupText
            )}
            isOpen={isOpenSupplierModal}
            handleClose={closeSupplierModal}
        >
            <>
                <GridContainer data-test-selector="navigationList" as="ul">
                    <StyledWrapper className="adiexclusivesection popup-scroll-height-webkit">
                        <Typography as="h2"></Typography>
                        <GridItem className="prorewardssection">
                            <Typography as="h4">{translate(hmiRewardsSettingSettings.suppliersHeading1)}</Typography>
                        </GridItem>
                        {proRewardsModalSupplier1 &&
                            proRewardsModalSupplier1.map((item : any) => (
                                <GridItem as="li" key={item.id}>
                                    <Link
                                        href={item.imageLink}
                                        target="_self"
                                        data-test-selector="navigationList-Addresses"
                                        data-ga-promo={"ADI-loyalty_Featured-Suppliers-" + item.brandName}
                                    >
                                        <Img src={item.imageUrl} alt="ADI Pro Logo" />
                                    </Link>
                                </GridItem>
                            ))}

                        <GridItem className="prorewardssection">
                            <Typography as="h4">{translate(hmiRewardsSettingSettings.suppliersHeading2)}</Typography>
                        </GridItem>
                        {proRewardsModalSupplier2 &&
                            proRewardsModalSupplier2.map((item : any) => (
                                <GridItem as="li" key={item.id}>
                                    <Link
                                        href={item.imageLink}
                                        target="_self"
                                        data-test-selector="navigationList-Account Settings"
                                        data-ga-promo={"ADI-loyalty_Featured-Suppliers-" + item.brandName}
                                    >
                                        <Img src={item.imageUrl} alt="ADI Pro Logo" />
                                    </Link>
                                </GridItem>
                            ))}
                    </StyledWrapper>
                </GridContainer>
            </>
        </ADIBrandsRewardsModal>
    );
};
export default connect(mapStateToProps)(withTheme(ADIProrewardsandsuppliers));